import React, { Component } from "react";
import { Button } from "antd";

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  componentDidMount() {}

  render() {
    const { loading } = this.props;
    return (
      <span>
        <Button
          icon="save"
          style={{ marginRight: 10 }}
          onClick={this.props.handleClick("audit")}
          loading={loading}
        >
          提交审核
        </Button>
      </span>
    );
  }
}

export default BaseForm;



// WEBPACK FOOTER //
// ./src/components/comm/workflow/submitOp.js